import { StepProgressItem } from './components/StepProgressItem/StepProgressItem'
import * as $ from './StepProgress.styled'

export type StepProgressStatus = 'incomplete' | 'current' | 'complete' | 'skipped'

export interface StepProgressStep<TId extends string> {
  id: TId
  label: string
  status: StepProgressStatus
}

export interface StepProgressProps<TId extends string> {
  steps: readonly StepProgressStep<TId>[]
  /** Turns complete and skipped steps into buttons that navigate back to them. */
  onStepClick?: (id: TId) => void
}

export function StepProgress<TId extends string>({ steps, onStepClick }: StepProgressProps<TId>) {
  return (
    // Safari drops list semantics from a list styled with `list-style: none`.
    <$.List role="list">
      {steps.map((step, index) => {
        const isVisited = step.status === 'complete' || step.status === 'skipped'

        return (
          <StepProgressItem
            key={step.id}
            number={index + 1}
            label={step.label}
            status={step.status}
            isFirst={index === 0}
            isLast={index === steps.length - 1}
            onClick={onStepClick && isVisited ? () => onStepClick(step.id) : undefined}
          />
        )
      })}
    </$.List>
  )
}
